"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointerEventProvider = void 0;
const canvas_dimensions_1 = require("../../../templating/canvas-dimensions");
class PointerEventProvider {
    constructor(attachPoint) {
        this.attachPoint = attachPoint;
        this.canvasDimensions = canvas_dimensions_1.CanvasDimensions.createDefault();
    }
    updatePointerEvent($event, writeTo) {
        this.attachPoint.updateBoundingRects();
        writeTo.$event = $event;
        const offsetX = $event.clientX - this.attachPoint.canvasDims.boundingRect.getXMin();
        const offsetY = $event.clientY - this.attachPoint.canvasDims.boundingRect.getYMin();
        // make y grow up instead of down
        writeTo.pointerCssPosition.update(offsetX, this.canvasDimensions.cssDims.getYRange() - offsetY);
        writeTo.pointerCssPosition.mat3Multiply(this.canvasDimensions.transforms.cssToClip, writeTo.pointerClipPosition);
        writeTo.canvasDims = this.canvasDimensions;
    }
    setCanvasDims(canvasDims) {
        this.canvasDimensions = canvasDims;
    }
}
exports.PointerEventProvider = PointerEventProvider;
//# sourceMappingURL=pointer-event-provider.js.map